import { InsModDate } from './date.model';

export class Doctor extends InsModDate {
	id?: number;
	piva?: string;
	cityofresidence?: string;
	cap?: string;
	comune?: string;
	address?: string;
	mobile?: string;
	landline?: string;
	email?: string;
}
